import { Layout } from 'antd';
import React from 'react';
import '@/Layout/styles/content.css';

const ContentAntd = Layout.Content;

const Content: React.FC<{}> = ({ children }) => (
  <ContentAntd>
    <main className="main">
      <div className="main_content">{children}</div>
    </main>
  </ContentAntd>
);

export default Content;
